
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.446 1A6.563 6.563 0 0123 7.554v8.892a6.56 6.56 0 01-6.553 6.553H7.555A6.562 6.562 0 011 16.448V7.554A6.563 6.563 0 017.555 1zm.001 2.214H7.555a4.34 4.34 0 00-4.342 4.34v8.892a4.34 4.34 0 004.342 4.34h8.891a4.34 4.34 0 004.34-4.34h.002V7.555a4.34 4.34 0 00-4.34-4.34zM12 6.31a5.69 5.69 0 110 11.38 5.69 5.69 0 010-11.38zm0 2.211a3.477 3.477 0 000 6.955 3.478 3.478 0 000-6.955zm5.7-3.532a1.364 1.364 0 11.001 2.728 1.364 1.364 0 010-2.728z"}})])
          )
        }
      }
    